import React, { useContext } from "react";
import styled from "styled-components";

import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    LinearProgress as MuiLinearProgress
} from "@material-ui/core";

import PageStoreContext from "../../context";
import { useStores } from "../../../../../../hooks";
import { observer } from "mobx-react";
import { localize } from "../../../../../../common/libs";
import { useTranslation } from "react-i18next";
import { MenuItemRevenueStats } from "../../../../../../services/stats/models";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${props => props.theme.spacing(12)}px);
`;

const LinearProgress = styled(MuiLinearProgress)`
  height: 14px;
  width: 180px;
  border-radius: 3px;
  background: ${props => props.theme.palette.grey[200]};
`;


const TopItemsTable = ({ result }: { result: MenuItemRevenueStats [] }) => {
    const { i18n, t } = useTranslation(["general", "stats"]);

    const pageStore = useContext(PageStoreContext);


    const { constantsStore } = useStores();


    return (
        <Paper>
            <TableWrapper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" scope="row">
                                {t("stats:positions")}
                            </TableCell>
                            <TableCell style={{
                                width: 200
                            }}>
                                {t("stats:revenueOrders")}
                            </TableCell>
                            <TableCell style={{
                                width: 250
                            }}>
                                {t("stats:percentOfRevenue")}
                            </TableCell>
                            <TableCell style={{
                                width: 250
                            }}>
                                {t("stats:percentOfOrders")}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            result.map(item => {
                                const formatter = constantsStore.getCurrencyFormatter(item.revenue.currencyId);
                                const { ordersAmount, totalOrdersPrice } = pageStore.generalStats;

                                const revenuePercentage = (item.revenue.price / totalOrdersPrice.price) * 100;
                                const ordersPercentage = (item.totalOrdersCount / ordersAmount) * 100;


                                return <TableRow key={item.menuItemId}>
                                    <TableCell scope="row">
                                        {localize(item.menuItemName)}
                                    </TableCell>
                                    <TableCell style={{
                                        width: 200
                                    }}>
                                        {formatter.toShowFormatted(item.revenue.price)} <br/>
                                        {item.totalOrdersCount} шт.

                                    </TableCell>
                                    <TableCell style={{
                                        width: 250
                                    }}>
                                        {revenuePercentage.toFixed(2)} %
                                        <LinearProgress
                                            variant="determinate"
                                            value={revenuePercentage}
                                            color="secondary"
                                        />

                                    </TableCell>
                                    <TableCell style={{
                                        width: 250
                                    }}>
                                        {ordersPercentage.toFixed(2)} %
                                        <LinearProgress
                                            variant="determinate"
                                            value={ordersPercentage}
                                            color="secondary"
                                        />
                                    </TableCell>
                                </TableRow>;
                            })
                        }
                    </TableBody>
                </Table>
            </TableWrapper>
        </Paper>
    );
};

export default observer(TopItemsTable);
